import { AccountData, Campaign, Event, Follower } from "@markit/common.types";
import {
  getEventData,
  getUserCampaignData,
  getUserData,
  getUserFollowerData,
} from "./FirebaseUtils";

export const fetchSingleUser = async (
  userId: string,
  followingAccountData: AccountData[],
  callbackFn?: (userData: AccountData) => void,
  failFn?: () => void
) => {
  let userData = followingAccountData.find(
    (userData) => userData.uid === userId
  );
  if (!userData) {
    userData = await getUserData(userId);
  }

  if (callbackFn && userData) callbackFn(userData);
  if (failFn && userData === undefined) failFn();
  return userData;
};

export const fetchSingleEvent = async (
  eventId: string,
  events: Event[],
  callbackFn?: (eventData: Event) => void,
  failFn?: () => void
) => {
  let eventData = events.find((event) => event.id === eventId);
  if (!eventData) {
    eventData = await getEventData(eventId);
  }

  if (callbackFn && eventData) callbackFn(eventData);
  if (failFn && eventData === undefined) failFn();
  return eventData;
};

export const fetchSingleFollower = async (
  creatorId: string,
  userId: string,
  followersData: Follower[],
  callbackFn?: (followerData: Follower) => void,
  failFn?: () => void
) => {
  let followerData = followersData.find(
    (followerData) => followerData.uid === userId
  );
  if (!followerData) {
    followerData = await getUserFollowerData(creatorId, userId);
  }

  if (callbackFn && followerData) callbackFn(followerData);
  if (failFn && followerData === undefined) failFn();
  return followerData;
};

export const fetchSingleCampaign = async (
  userId: string,
  campaignId: string,
  campaigns: Campaign[],
  callbackFn?: (campaign: Campaign) => void
) => {
  let campaign = campaigns.find((campaign) => campaign.id === campaignId);
  if (!campaign) {
    campaign = await getUserCampaignData(userId, campaignId);
  }
  if (callbackFn && campaign) callbackFn(campaign);
  return campaign;
};
